
export function resolucion_tablet(): boolean {
    if (Math.abs(window.screen.width/window.screen.height - 4/3) < 0.1) return true
    if (Math.abs(window.screen.width/window.screen.height - 3/4) < 0.1) return true
    return false
}
